module.exports = __webpack_public_path__ + "img/new5.b6fcd972.png";